
import{Link,useLocation}from"react-router-dom"

interface P{user:any;onClose:()=>void}

const NAV=[
  {to:"/feed",l:"Home",d:"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"},
  {to:"/trending",l:"Popular",d:"M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"},
  {to:"/topics",l:"Topics",d:"M7 20l4-16m2 16l4-16M6 9h14M4 15h14"},
  {to:"/search",l:"Search",d:"M21 21l-4.35-4.35M17 11A6 6 0 105 11a6 6 0 0012 0z"},
]
const UNAV=[
  {to:"/notifications",l:"Notifications",d:"M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"},
  {to:"/messages",l:"Messages",d:"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"},
  {to:"/bookmarks",l:"Saved",d:"M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"},
  {to:"/following",l:"Following",d:"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"},
]

export function Sidebar({user,onClose}:P){
const{pathname}=useLocation()
const isA=(to:string)=>pathname===to||pathname.startsWith(to+"/")

const Item=({to,l,d,small=false}:{to:string;l:string;d:string;small?:boolean})=>(
<Link to={to} onClick={onClose}
  className="flex items-center gap-2.5 px-2.5 py-2 rounded text-sm font-semibold transition-all"
  style={{color:isA(to)?"var(--brand)":"var(--text2)",background:isA(to)?"rgba(255,69,0,.1)":"transparent",fontSize:small?".8rem":".875rem"}}>
  <svg className="flex-shrink-0" width={small?14:16} height={small?14:16} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={isA(to)?2.5:2}>
    <path strokeLinecap="round" strokeLinejoin="round" d={d}/>
  </svg>
  {l}
</Link>
)

return(
<nav className="flex flex-col h-full py-3 px-2 overflow-y-auto" style={{overscrollBehavior:"contain"}}>
  {user&&(
    <div className="px-1 mb-3">
      <Link to="/post/create" onClick={onClose} className="sq-btn sq-btn-primary w-full justify-center py-2 text-xs">
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4"/></svg>
        Create Post
      </Link>
    </div>
  )}

  <div className="space-y-0.5 mb-2">
    {NAV.map(n=><Item key={n.to} to={n.to} l={n.l} d={n.d}/>)}
  </div>

  {user&&(
    <>
      <div style={{height:1,background:"var(--border)",margin:"8px 4px"}}/>
      <p className="text-xs font-bold uppercase tracking-wider px-2.5 mb-1" style={{color:"var(--text3)"}}>My Stuff</p>
      <div className="space-y-0.5 mb-2">
        {UNAV.map(n=><Item key={n.to} to={n.to} l={n.l} d={n.d}/>)}
        <Item to={`/profile/${user.username}`} l="Profile" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
      </div>
    </>
  )}

  <div style={{height:1,background:"var(--border)",margin:"8px 4px"}}/>
  <div className="space-y-0.5">
    <Item to="/settings" l="Settings" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z" small/>
    <a href="https://policies.squids.co.za" target="_blank" rel="noreferrer"
      className="flex items-center gap-2.5 px-2.5 py-2 rounded text-xs font-semibold transition-all"
      style={{color:"var(--text3)"}}>
      <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      Policies & Help
    </a>
  </div>

  <div className="mt-auto pt-3 px-2">
    <p className="text-xs" style={{color:"var(--text3)"}}>&copy; {new Date().getFullYear()} SQUIDS · <a href="https://squids.co.za" className="hover:text-brand" style={{color:"inherit"}}>squids.co.za</a></p>
  </div>
</nav>
);}
